import React, { useMemo, useState } from 'react'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'
import { Button, Form, OverlayTrigger, Popover } from 'react-bootstrap'
import DeleteIcon from '../../../assets/img/svg/delete-icon.svg'
import AddIcon from '../../../assets/img/svg/add-icon.svg'
import InfoIcon from '../../../assets/img/svg/info-icon.svg'
import { useSelector } from 'react-redux'
import DeletePopup from '../../../component/deletePopup'
import { ICAL_MSG } from '../../../util/constant'

const ICallForm = ({ activePopover, setActivePopover }) => {
  const {
    control,
    trigger,
    formState: { errors }
  } = useFormContext()
  const { fields, remove, append } = useFieldArray({
    control,
    name: 'propertyICalLink'
  })
  const [deleteId, setDeleteId] = useState(null)
  const { user } = useSelector(({ auth }) => auth)
  const { iCalData } = useSelector(({ property }) => property)
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const openDeleteModal = (id) => {
    setDeleteId(id)
    setIsDeleteModalOpen(!isDeleteModalOpen)
  }
  
  const disable = useMemo(() => user?.invoice_payment && !user?.is_card, [user])

  // State to track the currently open popover

  // Function to toggle a specific popover
  const togglePopover = (id) => {
    setActivePopover((prev) => (prev === id ? null : id))
  }

  const currentTooltip = iCalData?.length && iCalData[currentIndex]

  const handleNext = () => {
    if (currentTooltip.has_next) {
      setCurrentIndex((prevIndex) => prevIndex + 1)
    }
  }

  const handlePrevious = () => {
    if (currentTooltip.has_previous) {
      setCurrentIndex((prevIndex) => prevIndex - 1)
    }
  }

  // const checkboxOptions = ['Cleaning on checkout', 'Cleaning on checkin']
  const checkboxOptions = []
  // const selectedValue = watch('cleaning_on')

  // const handleCheckboxChange = (value) => {
  //   setValue('cleaning_on', value === selectedValue ? null : value)
  // }

  const popoverClick = (
    <Popover id="popover-trigger-click" title="Popover bottom">
      <div className="popover-content-custom p-3">
        <strong className="popover-title">{currentTooltip?.category}</strong>
        <p className="popover-description">{currentTooltip?.tool_tip}</p>
        <div className="popover-buttons">
          {currentTooltip?.has_previous && (
            <Button className="popover-btn previous" variant="secondary" size="sm" onClick={handlePrevious} disabled={!currentTooltip?.has_previous}>
              Previous
            </Button>
          )}
          {currentTooltip?.has_next && (
            <Button
              className="popover-btn next d-flex flex-row-reverse"
              variant="secondary"
              size="sm"
              onClick={handleNext}
              disabled={!currentTooltip?.has_next}
            >
              Next
            </Button>
          )}
        </div>
      </div>
    </Popover>
  )

  return (
    <>
      <div className="row">
        {fields.map((field, index) => (
          <div key={field.id} className="row">
            <div className="col-md-6">
              <div className="input_icon_box">
                <div className="form-group mb-0 w-100">
                  <Controller
                    name={`propertyICalLink.${index}.ical_label`}
                    control={control}
                    defaultValue={field.ical_label}
                    render={({ field: { value, onChange }, fieldState }) => (
                      <>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="ICal Name"
                          disabled={disable}
                          value={value}
                          onChange={(val) => {
                            onChange(val)
                            trigger(`propertyICalLink.${index}.ical_label`)
                            if (errors.propertyICalLink?.[index]?.ical_link) {
                              trigger(`propertyICalLink.${index}.ical_link`)
                            }
                          }}
                        />
                        <small>{fieldState?.error?.message}</small>
                      </>
                    )}
                  />
                </div>
              </div>
            </div>
            <div className={'col-md-6'}>
              <div className="input_icon_box">
                <div className="form-group mb-0 w-100 input_with_icon">
                  <Controller
                    name={`propertyICalLink.${index}.ical_link`}
                    control={control}
                    defaultValue={field.ical_link}
                    render={({ field: { value, onChange }, fieldState }) => (
                      <>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="ICal Link"
                          value={value}
                          disabled={disable}
                          onChange={(val) => {
                            onChange(val)
                            trigger(`propertyICalLink.${index}.ical_link`)
                            if (errors.propertyICalLink?.[index]?.ical_label) {
                              trigger(`propertyICalLink.${index}.ical_label`)
                            }
                          }}
                        />
                        <small>{fieldState?.error?.message}</small>
                        <OverlayTrigger
                          trigger="click"
                          placement="top"
                          overlay={popoverClick}
                          rootClose // Ensures the popover closes when clicking outside
                          show={activePopover === index}
                          // onToggle={(isOpen) => setPopoverVisible(isOpen)} // Handle toggle events
                        >
                          <span className="input_icon_div" onClick={() => togglePopover(index)}>
                            <img src={InfoIcon} alt="Info" width={20} />
                          </span>
                        </OverlayTrigger>
                      </>
                    )}
                  />
                </div>

                {!disable && (
                  <>
                    {fields.length - 1 === index ? (
                      <div
                        className="icon_box_div add_icon"
                        onClick={() => {
                          append({ property_cleaning_icallink_id: null, ical_label: '', ical_link: '' })
                          setActivePopover(null) // Close the popover
                        }}
                      >
                        <img src={AddIcon} alt="upload" width={24} />
                      </div>
                    ) : (
                      <div className="icon_box_div delete_icon" onClick={() => openDeleteModal(index)}>
                        <img src={DeleteIcon} alt="upload" width={17} />
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
            {disable && <div className="col-md-11 fs-16 fw-400 red_color">{ICAL_MSG}</div>}
          </div>
        ))}
        {checkboxOptions.map((option, index) => (
          <div className="col-md-6" key={index}>
            <Controller
              name="cleaning_on"
              control={control}
              defaultValue="" // Default to no selection
              render={({ field, fieldState }) => (
                <>
                  <Form.Check
                    type="switch"
                    id={`custom-switch-${index}`}
                    label={option}
                    {...field}
                    checked={field.value === option} // Checked only if value matches the option
                    onChange={() => {
                      if (field.value == 'Cleaning on checkout') {
                        field.onChange('Cleaning on checkin')
                      } else {
                        field.onChange('Cleaning on checkout')
                      }
                      field.onChange(option) // Update the form value
                      // handleCheckboxChange(option) // Additional custom logic (if needed)
                      trigger('cleaning_on') // Trigger validation if needed
                    }}
                  />
                  <small className="text-danger">{fieldState?.error?.message}</small>
                </>
              )}
            />
          </div>
        ))}
      </div>
      {isDeleteModalOpen && (
        <DeletePopup
          isDeleteModalOpen={isDeleteModalOpen}
          toggle={() => openDeleteModal(null)}
          subText="Deleting the iCal link may result in charges since the property is scheduled within the next 2 hours. Are you sure you want to delete?"
        >
          <div className="multi_btn_div">
            <button type="button" className="btn common-outline-btn w-100" onClick={() => openDeleteModal(null)}>
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-danger common-field-btn w-100"
              onClick={() => {
                remove(deleteId)
                openDeleteModal(null)
              }}
            >
              Delete
            </button>
          </div>
        </DeletePopup>
      )}
    </>
  )
}

export default ICallForm
